import { DroneEntity } from "@src/core/features";
import { RouteWaypointEntity, SidebarType } from '@src/features/order/pages/upsert-mission-page/entities';

export enum TerrainMode {
    BASIC = 'BASIC',
    ADVANCED = 'ADVANCED',
    ABOVE_TERRAIN = 'ABOVE_TERRAIN',
}

export interface IUpsertMissionInitialState {
    terrainMode: TerrainMode;
    editableRoute: boolean;
    sidebarType: SidebarType;
    waypoints: RouteWaypointEntity[];
    hoveredDrone: DroneEntity | null;
    selectedDrone: DroneEntity | null;
}